import { useState, useCallback } from 'react';
import type { Supplier } from '../types/types';
import { supabase } from '../lib/supabase';
import { captureSupabaseError } from '../lib/sentry';

export function useImportSuppliers() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [result, setResult] = useState<any>(null);

  const importSuppliers = useCallback(
    async (orgId: string, suppliers: Supplier[]) => {
      setLoading(true);
      setError(null);
      setResult(null);

      try {
        const { data, error } = await supabase.functions.invoke(
          'import-suppliers',
          {
            body: { orgId, suppliers },
          }
        );

        if (error) {
          setError(error.message);
        } else {
          setResult(JSON.parse(data));
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (err: any) {
        captureSupabaseError(err, { op: 'suppliers.import' });
        setError(err.message ?? 'Unknown error');
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return { importSuppliers, loading, error, result };
}
